import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '../Ant';
import { ArrowRight } from '../icons';

interface CardDetailButtonProps {
  onOpen: () => void;
  testId?: string;
}

/** The card's own "go to details" arrow: the same action as the card, as a button Tab reaches. */
const CardDetailButton = ({ onOpen, testId }: CardDetailButtonProps) => {
  const { t } = useTranslation();

  const open = (event: MouseEvent<HTMLElement>) => {
    // The card around it opens the details on click as well.
    event.stopPropagation();
    onOpen();
  };

  return (
    <Tooltip title={t('transaction:goDetail')} placement="top" arrow={false}>
      <IconButton
        data-testid={testId}
        aria-label={t('transaction:goDetail')}
        icon={<ArrowRight />}
        onClick={open}
      />
    </Tooltip>
  );
};

export default CardDetailButton;
